import React from "react";
import { myUtilities } from "../Utils";

export const isPartialAmountEdited = (invoiceItem) => {
  const original = parseFloat(
    invoiceItem.payableAmount2 !== undefined ? invoiceItem.payableAmount2 : invoiceItem.payableAmount
  );
  return parseFloat(invoiceItem.payableAmount) < original;
};

export const renderCell = (item, gridIdx, invoiceItem, invData) => {
  const fieldName = item[0];
  const partialEnabled = invData.state.partialPaymentEnabledForGuestPay;
  const partialEdited = isPartialAmountEdited(invoiceItem);

  if (fieldName === 'payableAmount' && partialEnabled) {
    return (
      <td style={{ minWidth: '100px', padding: '2px' }} key={gridIdx} onClick={e => e.stopPropagation()}>
        <input
          type="number"
          min="0.01"
          max={invoiceItem.payableAmount2 !== undefined ? invoiceItem.payableAmount2 : invoiceItem.payableAmount}
          step="0.01"
          value={invoiceItem.payableAmount}
          onChange={e => invData.updateInvoicePartialPayment(invoiceItem.accountDocHeaderId, 'payableAmount', e.target.value)}
          style={{ width: '90px' }}
        />
      </td>
    );
  }

  if (partialEnabled && !partialEdited &&
      (fieldName === 'eippDisputeReasonCategory' ||
       fieldName === 'partialPaymentReason' ||
       fieldName === 'partialPaymentReason.reasonCodeDisplay' ||
       fieldName === 'partialPaymentComments')) {
    return <td style={{ minWidth: '115px', padding: '2px' }} key={gridIdx} />;
  }

  if (fieldName === 'eippDisputeReasonCategory' && partialEnabled) {
    return (
      <td style={{ minWidth: '130px', padding: '2px' }} key={gridIdx} onClick={e => e.stopPropagation()}>
        <select
          value={invoiceItem.partialPaymentReasonCategory || ''}
          onChange={e => {
            invData.updateInvoicePartialPayment(invoiceItem.accountDocHeaderId, 'partialPaymentReasonCategory', e.target.value);
            invData.fetchReasonCodes(e.target.value);
          }}
          style={{ width: '120px' }}
        >
          <option value="">{myUtilities.accountSpecificLanguage("invoicegrid.selectCategory", "Select Category")}</option>
          {invData.state.reasonCategories && invData.state.reasonCategories.map((cat, ci) => (
            <option key={ci} value={cat.value}>{cat.displayName}</option>
          ))}
        </select>
      </td>
    );
  }

  if ((fieldName === 'partialPaymentReason' || fieldName === 'partialPaymentReason.reasonCodeDisplay') && partialEnabled) {
    return (
      <td style={{ minWidth: '130px', padding: '2px' }} key={gridIdx} onClick={e => e.stopPropagation()}>
        <select
          value={invoiceItem.partialPaymentReason || ''}
          onChange={e => invData.updateInvoicePartialPayment(invoiceItem.accountDocHeaderId, 'partialPaymentReason', e.target.value)}
          style={{ width: '120px' }}
        >
          <option value="">{myUtilities.accountSpecificLanguage("invoicegrid.selectReason", "Select Reason")}</option>
          {invData.state.reasonCodes && invData.state.reasonCodes.map((code, ri) => (
            <option key={ri} value={code.value}>{code.displayName}</option>
          ))}
        </select>
      </td>
    );
  }

  if (fieldName === 'partialPaymentComments' && partialEnabled) {
    return (
      <td style={{ minWidth: '130px', padding: '2px' }} key={gridIdx} onClick={e => e.stopPropagation()}>
        <input
          type="text"
          maxLength={250}
          placeholder={myUtilities.accountSpecificLanguage("invoicegrid.comments", "Comments")}
          value={invoiceItem.partialPaymentComments || ''}
          onChange={e => invData.updateInvoicePartialPayment(invoiceItem.accountDocHeaderId, 'partialPaymentComments', e.target.value)}
          style={{ width: '120px' }}
        />
      </td>
    );
  }

  return (
    <td style={{ minWidth: '115px', padding: '2px' }} key={gridIdx}>
      {myUtilities.needCurrency(fieldName)}
      {myUtilities.toStringUtil(invoiceItem[fieldName], fieldName)}
    </td>
  );
};
